import { useFormik } from "formik";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import * as yup from "yup";
import useAddFormData from "../../../../Components/Hooks/useAddFormData";
import { useEffect, useState } from "react";
import Input, { NuDate, NuInput, NuSelect, NuTextArea } from "../../../../Components/Utils/Input";
import UseEditData from "../../../../Components/Hooks/useEditData";
import { useLocation, useParams } from "react-router-dom";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import axiosInstance from "../../../../Services/axiosCommon";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import DropDownAddMetaData from "../../../../Components/Utils/selectAddMetaData";

const EditReceivables = () => {
  // const {value:Category} = useFetchMataData(`/dropdown/dropdown-details/`,'Category_Recevable')
  const {value:status,getData:refstatus} = useFetchMataData(`/dropdown/dropdown-details/`,'Status_Recevable')
  const {value:AccountType } = useFetchMataData(`/dropdown/dropdown-details/`,'AccountType__Recevable')
  // const [loading, setLoading] = useState(false);
  const {officeId} =useParams();

  const { Oncancel, editData, contextHolder, isLoading } = UseEditData();
    const location = useLocation();
    const data = location.state.data;
    const from = location.state.from;

  const [createNew, setCreateNew] = useState({
    description: data?.description || "",
    amount: data?.amount || "",
    category: data?.category || "",
    accountType: data?.accountType || "",
    receiveFrom: data?.receiveFrom || "",
    // daysElapsed: data?.daysElapsed || "",
    dueDate: data?.dueDate || "",
    // receivedAmount: data?.receivedAmount || "",
    // balanceAmount: data?.balanceAmount || "",
    // paymentMethod: data?.paymentMethod || "",
    // receivedOn: data?.receivedOn || "",
    // comments: data?.comments || "",
    invoiceId: data?.invoiceId || "",
    status: data?.status || ""
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      // setLoading(true); 
      editData(`/receivable/edit-receivable/${data?.receivableId}`, value, resetForm, from)
      // setLoading(false)

    },
  });
  const { data: invoiceOutgoing } = UseDropDown('/invoices-outgoing/drop-down');
  const { data: customer } = UseDropDown('/customers/drop-down');
  return (
    <div className="w-full h-full py-2 px-4 ">
      <div className="flex justify-between ">
   
      <Breadcrumb
         items={
          [
            { name: "Payment",
            link: `/main/${officeId}/payments/receivables` },  
          {
            name: "Receivables",
            link: `/main/${officeId}/payments/receivables`
          },
          {
            name: "Edit Receivables"
          }]
         }
        />
        <BackButton />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-md overflow-hidden mt-4">
          <div className=" w-full h-full flex py-2 justify-start content-start flex-wrap  overflow-y-auto">
          <FormikSelectTwo
              label="Invoice"
              placeholder="Choose"
              Options={invoiceOutgoing}
              formik={formik}
              disabled={true}
              name="invoiceId"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            <NuInput
              type="number"
              label="Amount"
              placeholder="amount"
              formik={formik}
              name="amount"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            {/* <FormikSelectTwo
              label="Category"
              placeholder="Choose"
              Options={Category}
              formik={formik}
              name="category"
              width="w-full md:w-1/2 lg:w-1/3"
            /> */}
            <FormikSelectTwo
              label="Account Type"
              placeholder="Choose"
              Options={AccountType}
              formik={formik}
              name="accountType"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            
            <FormikSelectTwo
              label="Received From"
              placeholder="Choose"
              Options={customer}
              formik={formik}
              name="receiveFrom"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            {/* <NuInput
              type="number"
              label="Days Elapsed"
              placeholder="daysElapsed"
              formik={formik}
              name="daysElapsed"
               width="w-full md:w-1/2 lg:w-1/3"
            /> */}
            <NuDate
              label="Due Date"
              placeholder="dd/mm/yyyy"
              formik={formik}
              name="dueDate"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            {/* <NuInput
              type="number"
              label="Received Amount"
              placeholder="receivedAmount"
              formik={formik}
              name="receivedAmount"
              width="w-full md:w-1/2 lg:w-1/3"
            /> */}
            {/* <NuInput
              type="number"
              label="Balance Amount"
              placeholder="Balance Amount"
              formik={formik}
              name="balanceAmount"
               width="w-full md:w-1/2 lg:w-1/3"
            /> */}
            <NuInput
              type="text"
              label="Description"
              placeholder="Description"
              formik={formik}
              name="description"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            {/* <FormikSelectTwo
              label="Payment Method"
              placeholder="Choose"
              Options={[
                {value:"online",label:"online"},
                {value:"offline",label:"offline"},
              ]}
              formik={formik}
              name="paymentMethod"
             width="w-full md:w-1/2 lg:w-1/3"
            /> */}
            {/* <NuDate
              label="Received On"
              placeholder="dd/mm/yyyy"
              formik={formik}
              name="receivedOn"
              width="w-full md:w-1/2 lg:w-1/3"
            /> */}
             {/* <DropDownAddMetaData
                label="Status"
                placeholder="Choose"
                Options={status}
                formik={formik}
                name="status"
                width="w-full md:w-1/2 lg:w-1/3"
                getFunc={refstatus}
                displayProperty={"Status"}
                propertyName={"Status_Recevable"}
              /> */}
            {/* <FormikSelectTwo
              label="Status"
              placeholder="Choose"
              Options={status}
              formik={formik}
              name="status"
              width="w-full md:w-1/2 lg:w-1/3"
            /> */}
                       {/* <NuTextArea
              label="Comments"
              placeholder="comments"
              formik={formik}
              name="comments"
                width="w-full md:w-1/2 lg:w-1/3"
            />             */}
            <div className="w-full hidden md:block mx-auto my-4 mt-8 ">
              <div className="md:flex justify-end gap-4">
                <CancelButton handleClick={()=>{Oncancel(-1)}} />
                <SubmitButton isLoading={isLoading}/>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default EditReceivables;
